<app-conversation-picker
  [patientUids]="patientUids"
  [attached]="photos"
  [attachmentType]="'MEDIA'"
  (conversationId)="send($event)"
  (conversationTypeChange)="toConversationType = $event"
></app-conversation-picker>
